//eslint-disable-next-line @typescript-eslint/no-empty-interface

export interface AssistHoursMinutesBM {
  hours: number;
  minutes: number;
  fill: boolean;
}
